import { useFormikContext } from 'formik';
import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { cssTexte, LABEL_COL } from '../constantes';
import ChampAutocompletion from '../../Common/ChampAutocompletion';

type MultiSelectProps = {
    id: string;
    titre: string;
    values: string[];
    suggestions: string[];
    placeholder: string;
};

export const MultiSelect = (props: MultiSelectProps) => {
    const { id, titre, values, suggestions, placeholder } = props;
    const { setFieldValue } = useFormikContext();
    return (
        <Row>
            <Col xs={LABEL_COL}>{titre}</Col>
            <Col>
                {values && values.length > 0 ? (
                    <Card>
                        <Card.Body
                            style={{
                                padding: '8px',
                                paddingTop: '4px',
                                paddingBottom: '4px',
                                ...cssTexte,
                            }}
                        >
                            {values.map((c) => (
                                <div>
                                    {c}{' '}
                                    <FaTimes
                                        style={{
                                            verticalAlign: 'text-bottom',
                                            color: 'red',
                                            cursor: 'pointer',
                                        }}
                                        size={19}
                                        onClick={() => {
                                            if (values && values.includes(c))
                                                setFieldValue(
                                                    id,
                                                    values.filter((item) => item !== c),
                                                );
                                        }}
                                    />
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                ) : (
                    <Form.Control placeholder={placeholder} disabled size="sm"></Form.Control>
                )}
                <div className={'pt-2'}>
                    <ChampAutocompletion
                        id={id}
                        cacherTitre
                        isCreatable
                        avecUnBouton
                        estPetit
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        options={suggestions.map((s) => ({ label: s, value: s }))}
                        onChange={(option: { label: string; value: string }) => {
                            if (values && values.includes(option.value)) {
                                setFieldValue(
                                    id,
                                    values.filter((item) => item !== option.value),
                                );
                            } else if (values) {
                                setFieldValue(id, [...values, option.value]);
                            } else {
                                setFieldValue(id, [option.value]);
                            }
                        }}
                        value={''}
                    ></ChampAutocompletion>
                </div>
            </Col>
        </Row>
    );
};
